import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloseQuote2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="close-quote-2, blockquote"><path d="M10.25 4.75H2.75V13.0357H6.25V19.25C6.25 19.25 10.25 17.6964 10.25 13.0357V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M21.25 4.75H13.75V13.0357H17.25V19.25C17.25 19.25 21.25 17.6964 21.25 13.0357V4.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCloseQuote2;
